import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Import and register controllers
import NavbarController from "./navbar_controller"
import ModalController from "./modal_controller"
import ContactFormController from "./contact_form_controller"
import BookingController from "./booking_controller"
import CalendarController from "./calendar_controller"
import ContactController from "./contact_controller"
import ScrollRevealController from "./scroll_reveal_controller"
import FadeInController from "./fade_in_controller"
import FileUploadController from "./file_upload_controller"
import CustomDocumentsController from "./custom_documents_controller"
import DocumentSelectController from "./document_select_controller"
import DomaineSelectorController from "./domaine_selector_controller"

application.register("navbar", NavbarController)
application.register("modal", ModalController)
application.register("contact-form", ContactFormController)
application.register("booking", BookingController)
application.register("calendar", CalendarController)
application.register("contact", ContactController)
application.register("scroll-reveal", ScrollRevealController)
application.register("fade-in", FadeInController)
application.register("file-upload", FileUploadController)
application.register("custom-documents", CustomDocumentsController)
application.register("document-select", DocumentSelectController)
application.register("domaine-selector", DomaineSelectorController)

export { application }
